import * as types from '../../../../../constants/ActionNameConstants';

// Proofreader my files
export const proofreaderMyFilesRequest = (payload) => ({
  type: types.GET_PROOFREADER_MY_FILES_LIST_REQUEST,
  payload,
});

export const proofreaderMyFilesSuccess = (payload) => ({
  type: types.GET_PROOFREADER_MY_FILES_LIST_SUCCESS,
  payload,
});

export const proofreaderMyFilesFailure = (error) => ({
  type: types.GET_PROOFREADER_MY_FILES_LIST_FAILED,
  error,
});
